import React from 'react';
import { Facebook, Share2 } from 'lucide-react';

interface SocialShareWidgetProps {
  url?: string;
  title?: string;
  description?: string;
  imageUrl?: string;
  compact?: boolean;
  className?: string;
}

const SocialShareWidget: React.FC<SocialShareWidgetProps> = ({
  url = window.location.href,
  title = document.title,
  description = document.querySelector('meta[name="description"]')?.getAttribute('content') || '',
  imageUrl = document.querySelector('meta[property="og:image"]')?.getAttribute('content') || '',
  compact = false,
  className = ''
}) => {
  // Share functions
  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(title)}`, '_blank');
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(url).then(() => {
      alert('Länk kopierad till urklipp!');
    });
  };

  if (compact) {
    return (
      <div className={`flex space-x-2 ${className}`}>
        <button 
          onClick={shareOnFacebook}
          className="p-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors"
          aria-label="Dela på Facebook"
        >
          <Facebook size={16} />
        </button>
        <button 
          onClick={copyToClipboard}
          className="p-2 bg-gray-600 text-white rounded-full hover:bg-gray-700 transition-colors"
          aria-label="Kopiera länk"
        >
          <Share2 size={16} />
        </button>
      </div>
    );
  }

  return (
    <div className={`space-y-3 ${className}`}>
      <h3 className="text-lg font-medium mb-2">Dela denna sida</h3>
      <div className="flex flex-wrap gap-2">
        <button 
          onClick={shareOnFacebook}
          className="flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-none transition-colors"
        >
          <Facebook size={18} className="mr-2" />
          Facebook
        </button>
        <button 
          onClick={copyToClipboard}
          className="flex items-center px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-none transition-colors"
        >
          <Share2 size={18} className="mr-2" />
          Kopiera länk
        </button>
      </div>
    </div>
  );
};

export default SocialShareWidget;